import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const listProducts = (params = {}) =>
  client.get("/products", { params }).then((r) => r.data);

export const getProduct = (slug) =>
  client.get(`/products/${slug}`).then((r) => r.data);

export const getRelated = (slug) =>
  client.get(`/products/${slug}/related`).then((r) => r.data);

export const suggest = (q) =>
  client.get("/products/suggest", { params: { q } }).then((r) => r.data);

export const listBlog = (category) =>
  client.get("/blog", { params: category ? { category } : {} }).then((r) => r.data);

export const getBlogPost = (slug) =>
  client.get(`/blog/${slug}`).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  client.post("/newsletter", { email }).then((r) => r.data);

export const fetchSiteContent = () =>
  client.get("/site-content").then((r) => r.data);

export const listCategories = () => client.get("/categories").then((r) => r.data);
export const fetchProductReviews = (slug) => client.get(`/reviews/${slug}`).then((r) => r.data);
export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_d49e4d80-f1c4-4c5f-8ece-a002b2e27159/artifacts/nw1teuke_Untitled%20design%20%281%29.png";
